import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollLink() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, key]); // Trigger on URL change OR same-link click (key change)

  return null;
}